
import { ActionTree } from 'vuex';
import { GspRoleDataState } from './types';
import { RootState } from '../../types';
import { defaultBackendGspRoleData } from '@/shared/backend/gspRoleData';
import { Logger } from 'fsts';
import module_utils from '../module_utils';
import gspRoleData, { Value, GspRoleData } from '@/shared/model/gspRoleData';
import { AxiosResponse } from 'axios';
import i18n from '@/i18n';

const logger = new Logger('actions.gspRolesData');
export const actions: ActionTree<GspRoleDataState, RootState> = {
  getGspRolesData({ commit, dispatch, getters, rootGetters }, payload?: { searchParams?: any,roleId?: number }) {
    commit('setGspRolesDataIsLoading', true);
    let searchParams = payload?.searchParams ?? getters.getGspRolesDataSearchParams;
    return defaultBackendGspRoleData
      .getGspRolesData(searchParams, payload?.roleId)
      .then((response: AxiosResponse<Value>) => {
        commit('setGspRolesData', response.data);
        commit('setGspRolesDataIsLoading', false);
        return response.data;
      })
      .catch((e: any) => {
        commit('setGspRolesDataIsLoading', false);
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  getGspRoleData({ commit, dispatch }, id: string) {
    return defaultBackendGspRoleData
      .getGspRoleData(id)
      .then((response: AxiosResponse<GspRoleData>) => {
        return response.data;
      })
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  updateGspRoleData({ commit, dispatch }, file: GspRoleData) {
    return defaultBackendGspRoleData
      .updateGspRoleData(file)
      .then(
        (
          response: AxiosResponse<{
            errors: [];
            id: string;
            isValid: boolean;
            result: GspRoleData;
          }>
        ) => {
          module_utils.ok(i18n.tc(`success.gspRoleData_update`), commit);
          return response.data;
        }
      )
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  deleteGspRoleData({ commit, dispatch }, id: string) {
    return defaultBackendGspRoleData
      .deleteGspRoleData(id)
      .then(
        (
          response: AxiosResponse<{
            errors: [];
            id: string;
            isValid: boolean;
            result: GspRoleData;
          }>
        ) => {
          return response;
        }
      )
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },

  resetGspRoleData({ commit, dispatch }){
    commit('resetGspRoleData');
  }
};
